import { Folder } from './Folder';
import { MemoCollaborator } from './MemoCollaborator';
import { PipelineColumn } from './PipelineColumn';
import { User } from './User';
import { Workspace } from './Workspace';

export enum MemoType {
    PRIVATE = 'Private',
    SHARED = 'Shared',
    WORKSPACE = 'Workspace',
}

export enum MemoDocumentType {
    DRAFT = 'Draft',
    TEMPLATE = 'Template',
}

export interface Memo {
    id: string;
    workspace: Workspace;
    user: User;
    type: MemoType;
    favorited: boolean;
    locked: boolean;
    archived: boolean;
    banner: string | undefined;
    avatar: string | undefined;
    emoji: string | undefined;
    icon: string | undefined;
    foregroundColor: string | undefined;
    backgroundColor: string | undefined;
    title: string | undefined;
    body: string | undefined;
    documentType: MemoDocumentType | undefined;
    publiclyVisible: boolean;
    publicMetadataVisibility?: {
        activity?: boolean;
        author?: boolean;
        comments?: boolean;
        workspace?: boolean;
        company?: boolean;
    };
    bannerVisible: boolean;
    tocVisible: boolean;
    sourcesVisible: boolean;
    folder: Folder;
    collaborators: MemoCollaborator[];
    pipelineColumn: PipelineColumn;
    views: number | undefined;
    createdAt: Date;
    updatedAt: Date;
    deletedAt?: Date;
}
